import type {
  ProgressBarConfig,
  ProgressBarDeviceConfig,
  ResolvedProgressBarDeviceConfig,
  ResolvedProgressBarWidgetConfig,
} from "@intelligems/ig-types";

import { createShippingProgressBarConfig } from "./createShippingProgressBarConfig";

export function createProgressBarConfigForSitewide(
  widget: ResolvedProgressBarWidgetConfig
): ProgressBarConfig | undefined {
  const desktop = createShippingConfig(widget.desktop);
  const mobile = createShippingConfig(widget.mobile);
  if (!desktop || !mobile) return undefined;
  return {
    unitType: "dollar",
    discountType: "dollar",
    afterDiscount: true,
    isEntireStore: true,
    desktop,
    mobile,
  };
}

function createShippingConfig(
  widget: ResolvedProgressBarDeviceConfig
): ProgressBarDeviceConfig | undefined {
  const threshold = widget.variables.defaultShippingThreshold;
  if (threshold === undefined) return undefined;

  return createShippingProgressBarConfig(widget, threshold);
}
